import React from 'react'
import '../css/Home.css'
import Logo from '../images/Logo.png'
import Logo2 from '../images/Logo2.png'
import Reformed from '../images/reformedsemimg.jpg'
const HomePage = () => {
  return (
    <div className="homeContainer">
      <div className='hide'>

      </div>
         <div className="home">
            <img className="logo" src={Logo}/>
            <h2>Reformed Seminary</h2>
            <p>대한예수교장로회 & 리폼드총회신학대학/대학원</p>
            <p className="info">
            사랑하는 신학도 여러분! Reformed Seminary 총회 신학교에 오신것을 진심으로 환영하며 감사드립니다. 본 신학교는 23년된 역사와 전통을 자랑하는 하나님의 선지학교 입니다. 설립목적에 의해 미래에도 칼빈 주의적 개혁 주의의 신앙과 전통을 계승하고 발전 시키며, 성경은 일점일획도 과감할수 없는 정확 무오한 하나님의 말씀을 지켜내는 보수신학정통 신학교 입니다. 오늘날 세속주의 물결의 시대 풍조에 휩싸여 많은 신학교가 타락의 길, 배교 주의로 치닫고 있으나, 본 신학교는 지성과 영성을 겸비한 탁월한 영적 지도자와 사명자를 양성하는 신학교이며, 자유주의, 혼합주의, 종교다원주의 등을 철저히 배격하며, 오직 진리의 말씀, 뿌리깊은영성, 바른신학, 바른제자를 훈련시키는 자랑스런 보수신학교 입니다. 많은 제자들이 바른 신학을 배워 말씀과 기도로 무장하여 선교지와, 목회지에서 검증된 사명자로 헌신, 충성하고 있읍니다. 본 학교의 제자 모든 학도들이 주님께 칭찬받는 종들이 되기를 기원 합니다.
            </p>
            <img className="gp" src={Logo2} />
            <p className="miniB">총장 김 용익 박사</p>
            <p className="miniB">(Yong Ik Kim, Th. D.)</p>
            <p className="miniB">총장인사말씀</p>
         </div>
    </div>
  )
}

export default HomePage